import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import {ISliderOptions} from '../../interfaces/islider-options';

@Component({
	selector: 'as-slider',
	templateUrl: './as-slider.component.html',
	styleUrls: ['./as-slider.component.scss'],
})
export class AsSliderComponent implements OnInit {
	@Input() sliderOptions: ISliderOptions;
	@Input() value: ISliderOptions;

	@Output() onValueChange = new EventEmitter();

	constructor() {
	}

	ngOnInit(): void {
	}
}
